module.exports = __webpack_public_path__ + "static/ouestfrance-9a2e7f4ea74fbf4edc898917cea4b834.png";